import { Box, Paper, Table, TableCell, TableContainer, TableRow, TableFooter } from '@mui/material';
import PropTypes from 'prop-types';

// Components

// Utils and Helpers
import { numberFormat } from 'helpers/i18n';

const TransactionsSummaryFooter = ({ childTransactionsTotalAmount }) => (
    <Paper
        sx={{
            width: '100%',
            overflow: 'hidden',
            /* marginTop: '1em', */
            marginBottom: '3em'
        }}>
        <TableContainer sx={{ maxHeight: 1440 }}>
            <Table stickyHeader aria-label="sticky table" sx={{ border: 'none' }}>
                <TableFooter sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableRow>
                        <TableCell className="card-table-row-cell" align="left" colSpan="3">
                            <Box sx={{ fontWeight: 'bold' }}>Net Transaction Amount</Box>
                        </TableCell>
                        <TableCell className="card-table-row-cell" align="right">
                            <Box sx={{ fontWeight: 'bold' }}>{numberFormat(childTransactionsTotalAmount, 2, 2)}</Box>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    </Paper>
);

TransactionsSummaryFooter.propTypes = {
    childTransactionsTotalAmount: PropTypes.number
};

export default TransactionsSummaryFooter;
